import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { ContexteUtilisateur } from 'src/models/pilotage/contextePilotageUtilisateurModel';
import { map, Observable } from 'rxjs';
import { ContenuSessionModel } from 'src/models/contenuSessionModel';
import { DetailSessionModel } from 'src/models/Session/detail-session-model';
import { UtilisateurService } from './utilisateur.service';
import { InfosCertificatModel } from 'src/models/Session/infos-certificat-model';
import moment from'moment';
import { TranslateService } from '@ngx-translate/core';
import { EvenementSessionScormModel } from 'src/models/evenement-session-scorm-model';
import { EvenementModel } from 'src/models/evenement-model';
import { SessionProgressionModel } from 'src/models/Session/session-progression-model';

@Injectable({
  providedIn: 'root'
})
export class ContenuSessionService {

  private baseUrl = environment.api_LMS + 'Session';

  public contexteUtilisateur!: ContexteUtilisateur;

  constructor(private http: HttpClient, private utilisateurService: UtilisateurService, private translateService: TranslateService) { }

   ObtenirProgressionPackage(scormPackageId: number, formationGroupeId: number | null | undefined): Observable<SessionProgressionModel> {
    let params: any = {
      packageId: scormPackageId,
      utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId,
      entiteId: this.utilisateurService.entiteUtilisateurSelectionnee.entiteId
    };

    if (formationGroupeId !== null && formationGroupeId !== undefined) {
      params.formationGroupeId = formationGroupeId;
    }

    return this.http.get<SessionProgressionModel>(`${this.baseUrl}/ObtenirProgressionPackage`, { params });
  }

  obtenirContenuSessionsSelonRole(entiteId: number, utilisateurId: number, estRoot: boolean, dateDebut: Date, dateFin: Date): Observable<ContenuSessionModel[]> {
    dateDebut = dateDebut ? dateDebut : moment().startOf('month').toDate();
    dateFin = dateFin ? dateFin : moment().toDate();
    const codeLangue = this.translateService.currentLang ? this.translateService.currentLang : 'fr';
    return this.http.get<ContenuSessionModel[]>(`${this.baseUrl}/ObtenirSessionsSelonRole`, { params: { entiteId: entiteId, utilisateurId: utilisateurId, estRoot: estRoot, dateDebut: dateDebut.toISOString(), dateFin: dateFin.toISOString() , codeLangue: codeLangue} });
  }

    obtenirSessionsCertificatSelonRole(entiteId: number, utilisateurId: number, estRoot: boolean, dateDebut: Date, dateFin: Date, ): Observable<ContenuSessionModel[]> {
    dateDebut = dateDebut ? dateDebut : moment().startOf('month').toDate();
    dateFin = dateFin ? dateFin : moment().toDate();
     const codeLangue = this.translateService.currentLang ? this.translateService.currentLang : 'fr';
    return this.http.get<ContenuSessionModel[]>(`${this.baseUrl}/ObtenirSessionsCertificatSelonRole`, { params: { entiteId: entiteId, utilisateurId: utilisateurId, estRoot: estRoot, dateDebut: dateDebut.toISOString(), dateFin: dateFin.toISOString(), codeLangue: codeLangue } });
  }

  obtenirContenuSessionSelonUtilisateur(utilisateurId: number, dateDebut?: Date, dateFin?: Date): Observable<ContenuSessionModel[]> {
    dateDebut = dateDebut  ? dateDebut : moment().startOf('month').toDate();
    dateFin = dateFin ? dateFin : moment().toDate();
    const codeLangue = this.translateService.currentLang ? this.translateService.currentLang : 'fr';
    return this.http.get<ContenuSessionModel[]>(`${this.baseUrl}/ObtenirSessionsSelonUtilisateur`, { params: { utilisateurId: utilisateurId, dateDebut: dateDebut.toISOString(), dateFin: dateFin.toISOString(), codeLangue: codeLangue} });
  }

  obtenirDetailSession(sessionId: number): Observable<DetailSessionModel> {
    return this.http.get<DetailSessionModel>(`${this.baseUrl}/ObtenirDetailSession`, { params: { sessionId: sessionId } });
  }

  creerSession(EvenementModel: EvenementModel): Observable<EvenementSessionScormModel[]> {
    return this.http.post<EvenementSessionScormModel[]>(`${this.baseUrl}/CreerSession`, EvenementModel);
  }

  obtenirDonneesSession(sessionId: number): Observable<EvenementSessionScormModel[]> {
    return this.http.get<EvenementSessionScormModel[]>(`${this.baseUrl}/GetDataSession`, { params: { sessionId: sessionId} });
  }

  obtenirInfosCertificat(packageId: number,  langue: string): Observable<InfosCertificatModel> {
    const codeLangue = this.translateService.currentLang ? this.translateService.currentLang : 'fr';
    return this.http.get<InfosCertificatModel>(`${this.baseUrl}/ObtenirInfosCertificat`, { params: { packageId: packageId, utilisateurId : this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId, langue: codeLangue } });
  }

  imprimerCertificatUtilisateur(infosCertificatModels: InfosCertificatModel[], langue: string): Observable<{ blob: Blob, contentType: string | null }> {
    return this.http.post(`${this.baseUrl}/ImprimerCertificatUtilisateur`, infosCertificatModels, {
      params: {
        langue: langue
      },
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        const contentType = response.headers.get('Content-Type');
        return { blob: response.body!, contentType };
      })
    );
  }

  telechargerDocumentFormation(scormPackageId: number,nomContentScormPackage: string,nomDocument: string): Observable<{ blob: Blob, contentType: string | null }> {
    var body = {
      scormPackageId: scormPackageId,
      utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId,
      NomContentScormPackage: nomContentScormPackage,
      nomDocument: nomDocument
    };
    return this.http.post(`${this.baseUrl}/TelechargerDocumentFormation`, body, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        const contentType = response.headers.get('Content-Type');
        return { blob: response.body!, contentType };
      })
    );
  }

 exporterContenus(ids: number[], codeLangue: string): Observable<{ blob: Blob, contentType: string }> {
  const options = {
    responseType: 'blob' as 'json',
    params: new HttpParams().set('codeLangue', codeLangue)
  };

  return this.http.post(
    `${this.baseUrl}/Exporter`,
    ids,
    options
  ).pipe(
    map((response: any) => {
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      return { blob, contentType: blob.type };
    })
  );
}

  exporterContenusPdf(ids: number[], codeLangue: string): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/ExporterPdf`, ids, {
      responseType: 'blob',
      params: { codeLangue }
    });
  }

  obtenirNombreSessionsCompleteesDemo(entiteId: number, utilisateurId: number, dateDebut: Date, dateFin: Date): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/ObtenirNombreSessionsCompleteesDemo`, {
      params: {
        entiteId: entiteId.toString(),
        utilisateurId: utilisateurId.toString(),
        dateDebut: dateDebut.toISOString(),
        dateFin: dateFin.toISOString()
      }
    });
  }

  hasSessionWithPackage(packageId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/HasSessionWithPackage`, {
      params: { packageId: packageId.toString() }
    });
  }
}
